import React from "react";
import { makeStyles } from "@material-ui/core";
import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";

const useStyles = makeStyles({
  button: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "0 14px",
    borderRadius: "8px",
    border: "1.5px dashed #003350",
    backgroundColor: "#EAF1FD",
    color: "#003350",
    cursor: "pointer",
    boxSizing: "border-box",
    textAlign: "left",
    transition: "background-color 0.15s ease",
    "&:hover": {
      backgroundColor: "#d9eaf9",
    },
  },
  icon: {
    fontSize: "20px",
    flexShrink: 0,
    width: "20px",
    height: "20px",
  },
  label: {
    fontSize: "16px",
    fontWeight: 500,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

type DocumentFileButtonProps = {
  label: string;
  onClick: () => void;
  height?: number | string;
};

const DocumentFileButton: React.FC<DocumentFileButtonProps> = ({ label, onClick, height = 96 }) => {
  const classes = useStyles();
  const resolvedHeight = typeof height === "number" ? `${height}px` : height;

  return (
    <button
      type="button"
      className={classes.button}
      style={{ height: resolvedHeight }}
      onClick={onClick}
    >
      <InsertDriveFileOutlinedIcon className={classes.icon} />
      <span className={classes.label}>{label}</span>
    </button>
  );
};

export default DocumentFileButton;
